
import React from 'react';
import { X, Check } from 'lucide-react';
import { useAudioLevels } from '../../hooks/useAudioLevels';
import { useLanguage } from '@/contexts/LanguageContext';

interface ListeningInterfaceProps {
  onCancel: () => void;
  onConfirm: () => void;
  isTranscribing?: boolean;
}

const ListeningInterface: React.FC<ListeningInterfaceProps> = ({
  onCancel,
  onConfirm,
  isTranscribing = false,
}) => {
  const audioLevels = useAudioLevels(!isTranscribing);
  const { t } = useLanguage();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-7 flex items-center gap-5 shadow-xl">
        {/* Cancel Button */}
        <button
          onClick={onCancel}
          className="w-14 h-14 flex items-center justify-center border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-100 bg-white active:bg-gray-200 transition-colors"
          style={{ borderRadius: 0 }}
        >
          <X className="w-7 h-7 text-gray-600" />
        </button>

        {/* Audio Bars and Text */}
        <div className="flex items-center gap-3">
          {/* Animated Audio Bars */}
          <div className="flex items-end gap-1 h-7">
            {audioLevels.map((level, index) => (
              <div
                key={index}
                className="w-2 bg-gray-400 rounded-sm transition-all duration-150 ease-out"
                style={{
                  height: `${level * 100}%`,
                  minHeight: '4px',
                }}
              />
            ))}
          </div>

          {/* Listening Text */}
          <span className="text-lg text-gray-600 font-medium">
            {isTranscribing ? t('chat.input.transcribing') : t('chat.input.listening')}
          </span>
        </div>

        {/* Confirm Button */}
        <button
          onClick={onConfirm}
          className="w-14 h-14 flex items-center justify-center bg-black hover:bg-gray-800 active:bg-gray-700 text-white transition-colors"
          style={{ borderRadius: 0 }}
        >
          <Check className="w-7 h-7" stroke="white" strokeWidth={3} />
        </button>
      </div>
    </div>
  );
};

export default ListeningInterface;
